import React from "react";
import { FaBootstrap, FaCode, FaHackerrank, FaHtml5, FaMedium, FaNode, FaReact } from "react-icons/fa";
import { SiExpressvpn, SiNetlify, SiTailwindcss } from "react-icons/si";
import ServiceItem from "./ServiceItem";

const serviceData = [
  {
    id: 1,
    icon: <FaCode  />,
    title: "Web Development",
    description:
      "A responsive web page design with core fundamental like vanila html, css and javascript",
  },
  {
    id: 2,
    icon: <FaMedium />,
    title: "Material UI Design",
    description:
      "Material UI is the way to design a web site with multiple device access platform",
  },
  {
    id: 3,
    icon: <FaReact  />,
    title: "React Front End",
    description:
      "React render a site throughout the users activity with diff algorithm and faster components",
  },
  {
    id: 4,
    icon: <FaBootstrap   />,
    title: "Bootstrap Layout",
    description:
      "Easy to design a web page using css framework, help of this manage design concepts highly",
  },
  {
    id: 5,
    icon: <FaNode />,
    title: "Node Js CRUD Operation",
    description:
      "Node.Js used for handle backend purpose throught the Javascript runtime activity",
  },
  {
    id: 6,
    icon: <SiExpressvpn />,
    title: "Express Js",
    description:
      "Express.Js used for make API for https request and response handle and frontend data load",
  },
  {
    id: 7,
    icon: <FaHackerrank/>,
    title: "Heroku Hosting",
    description:
      "Heroku used for hosting a site with semantic smile like a real site response with server side",
  },
  {
    id: 8,
    icon: <SiNetlify  />,
    title: "Netlify Hosting",
    description:
      "Netlify used for client site deploment related platform which is a free hosting popular site",
  },
];

const Service = () => {
  return (
    <section className="pb-10">
    <h3 style={{textAlign:'center', marginTop:'60px', marginBottom:'40px', fontWeight:'bold', fontSize:'26px'}}>Working ON</h3>
    <div style={{height:'5px', width:'50px', background:'#E54042', margin:'0 auto', marginTop:'-30px', marginBottom:'30px'}}></div>
      <div className="flex flex-wrap md:px-4">
        {serviceData.map((service, id) => (
          <ServiceItem service={service} key={id} />
        ))}
      </div>
    </section>
  );
};

export default Service;
